import React from 'react';
import { Table } from 'reactstrap';
import { EffectsModal } from '../EffectsModal';

export const DamageDescriptionModal = ({ title }) => EffectsModal({
  title,
  valid: '0 to 4',
  content: (
    <div>
      <p>
        For those events not offering a monetary evaluation of damage, the
        following five-level scale was used to classify damage (1990 dollars) and
        was listed in the Damage column. If the actual dollar amount of damage
        was listed, a descriptor was also added for search purposes.
      </p>
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">0</th>
            <td>NONE</td>
          </tr>
          <tr>
            <th scope="row">1</th>
            <td>LIMITED (roughly corresponding to less than $1 million)</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>MODERATE (~$1 to $5 million)</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>SEVERE (~$5 to $25 million)</td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td>EXTREME (~$25 million or more)</td>
          </tr>
        </tbody>
      </Table>
      <p>
        When possible, a rough estimate was made of the dollar amount of damage
        based upon the description provided, in order to choose the damage
        category. In many cases, only a single descriptive term was available.
        These terms were converted to the damage categories based upon the authors
        apparent use of the term elsewhere. In the absence of other information,
        LIMITED is considered synonymous with slight, minor, and light, SEVERE as
        synonymous with major, extensive, and heavy, and EXTREME as synonymous
        with catastrophic.
      </p>
      <p>
        Note: The descriptive terms relate approximately to current dollar
        values.
      </p>
    </div>
  ),
});
